import AdditionalInformationForm from "./additional-information-form";

export default AdditionalInformationForm;